const isNonBlankString = (value) =>
  typeof value === "string" && value.trim() !== "";

// Filename to display for a contract row, or null when the row has no
// downloadable file. Legacy rows can carry a filename without a blob, so both
// UploadContractFilename and AzureBlobName must be present.
export const getContractFilename = (row) =>
  isNonBlankString(row?.UploadContractFilename) &&
  isNonBlankString(row?.AzureBlobName)
    ? row.UploadContractFilename.trim()
    : null;

// ag-grid column definition shared by the distributor contract tables.
// valueGetter keeps filter, sort, tooltip and the default cell renderer on the
// same gated value without adding a synthetic field to the row data (row data
// is forwarded as router state by the Duplicate action).
export const contractFilenameColumnDef = {
  headerName: "Filename",
  colId: "Filename",
  filter: true,
  maxWidth: 320,
  valueGetter: (params) => getContractFilename(params.data),
  tooltipValueGetter: (params) => params.value ?? undefined,
};
